export default __webpack_public_path__ + "static/media/insights.748f6557.svg";